import { render, staticRenderFns } from "./TrackingForm.vue?vue&type=template&id=4d4c8c06&scoped=true"
import script from "./TrackingForm.vue?vue&type=script&lang=js"
export * from "./TrackingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c8c06",
  null
  
)

export default component.exports